exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-background[data-v-9633f29a]{background-color:silver\n}\n.cropper-banner[data-v-9633f29a]{max-height:5000px;max-width:1100px;background-color:#ddd\n}", ""]);

// exports
